export class SIQAudioPlayerTheme {
  thumbColor = "null";
  playButtonBackgroundColor = "null";
  incomingTrackColor = "null";
  outgoingTrackColor = "null";
  incomingButtonIconColor = "null";
  outgoingButtonIconColor = "null";
  outgoingDurationTextColor = "null";
  incomingDurationTextColor = "null";
}
//# sourceMappingURL=SIQAudioPlayerTheme.js.map